import React, { useState, useEffect, useRef } from 'react';

import { Container, SearchContainer, SearchInput, SearchIcon, ClearIcon, ItemsContainer, Item, Hr } from './styles';

const useOutsideClick = (ref, setItemsOpened) => {
  const handleClick = (e) => {
    if (ref.current) {
      setItemsOpened(ref.current.contains(e.target));
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  });
};

export default function SearchBar({ value, onChange, onSelect, items, renderItem, placeholder, style }) {
  const [itemsOpened, setItemsOpened] = useState(false);
  const containerRef = useRef(null);
  useOutsideClick(containerRef, setItemsOpened);

  useEffect(() => {
    return () => {
      onChange('');
      setItemsOpened(false);
    };
  }, [onChange]);

  useEffect(() => {
    setItemsOpened(items && items.length > 0 && value);
  }, [value, items]);

  return (
    <Container style={style} ref={containerRef}>
      <SearchContainer>
        <SearchInput
          value={value}
          placeholder={placeholder || 'Search...'}
          onChange={(e) => onChange(e.target.value)}
        />
        {value ? <ClearIcon onClick={() => onChange('')} /> : <SearchIcon />}
      </SearchContainer>
      {itemsOpened && (
        <ItemsContainer>
          {items &&
            items.map((item, index) => (
              <React.Fragment key={JSON.stringify(item)}>
                <Item
                  onClick={() => {
                    onSelect(item);
                    onChange('');
                  }}
                >
                  {renderItem(item)}
                </Item>
                {index !== items.length - 1 && <Hr />}
              </React.Fragment>
            ))}
        </ItemsContainer>
      )}
    </Container>
  );
}
